import { CookieConfig, CookieServices } from 'src/services/analytics/CookieConfig';

export const MARKETING_INFO_COOKIE_DURATION_DAYS = 90;

export const CLEAR_COOKIE_LIST = [
  'gaconnector_pages_visited_list',
  'gaconnector_all_traffic_sources',
];

const isCloverDomain: boolean = window.location.host.indexOf('clover.com') !== -1;

export function setCookie(name: string, value: string | string[], days?: number, includeSubdomains: boolean = true) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${(value || '')}` + `${includeSubdomains && isCloverDomain ? '; domain=.clover.com' : ''}` + `${expires}; path=/`;
}

export function setCookieIfValueExists(cookieName: string, value?: string, days = MARKETING_INFO_COOKIE_DURATION_DAYS) {
  if (value) {
    setCookie(cookieName, value, days);
  }
}

export function readCookie(name: string) {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  if (match) return match[2];
  return null;
}

export function readCookies(arr: string[]) : { [x: string] : string} {
  return arr.reduce((acc, property) => {
    const value = readCookie(property);
    if (!value) return acc;
    acc[property] = value;
    return acc;
  }, {});
}

export function controlCookieSize() {
  CLEAR_COOKIE_LIST.forEach(cookieName => {
    document.cookie = `${cookieName}=; expires=1970-07-01T16:00:00.000Z; path=/;domain=.${isCloverDomain ? 'clover.com' : window.location.host}`;
  });
}

export function readGAConnectorCookies(prependGaconnector?: boolean) {
  if (!window.gaconnector) return {};
  const gaFields = window.gaconnector.getCookieValues() || {};

  return prependGaconnector
  ? Object.entries(gaFields).reduce((accum, entry) => {
    const key = entry[0];
    const value = entry[1];
    accum[`gaconnector_${key}`] = value;
    return accum;
  }, {})
  : gaFields;
}

export function readCookiesForService(cookieConfig : CookieConfig[], service: keyof(CookieServices)) : {[x: string] : string} {
  return cookieConfig.reduce((acc, config) => {
    const isCookieSentToService = config && config.to && config.to[service];
    if (!isCookieSentToService) return acc;

    const serviceOptions = config.to[service]!;
    const needsSpecialName = !!(serviceOptions.as);

    const cookieName = needsSpecialName
    ? serviceOptions.as
    : config.cookieName;
    if (cookieName === undefined) return acc;

    const value = readCookie(config.cookieName);
    if (!value) return acc;
    acc[cookieName] = value;
    return acc;
  }, {});
}

export function eraseCookie(name: string, includeSubdomains?: boolean) {
  setCookie(name, '', -1, includeSubdomains);
}
